export default "__VITE_ASSET__va7cQFnH__"